export default [
    {
        name: "nameAr",
        label: "Arabic Name",
        type: "text",
        helpText: "Location Category name",
        errorMessage: "Location Category name is required",
        validation: {
            required: true,
        },
    },
    {
        name: "nameEn",
        label: "English Name",
        type: "text",
        helpText: "Location Category name",
        errorMessage: "Location Category name is required",
        validation: {
            required: true,
        },
    },
    {
        name: "cityRequired",
        label: "City Required",
        type: "select",
        data: [
            { value: "true", text: "Yes" },
            { value: "false", text: "No" },
        ],
    },
    {
        name: "locationRequired",
        label: "Location Required",
        type: "select",
        data: [
            { value: "true", text: "Yes" },
            { value: "false", text: "No" },
        ],
    },
];
